import { render, staticRenderFns } from "./OrganismTitleTextImage.vue?vue&type=template&id=dc2ab848&"
import script from "./OrganismTitleTextImage.vue?vue&type=script&lang=js&"
export * from "./OrganismTitleTextImage.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTitleTextImage.vue?vue&type=style&index=0&id=dc2ab848&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default})
